/**
 * @generated SignedSource<<8ee89c1209d14e387b795af8797d7c6f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PostStatusEnum = "acfDisabled" | "archived" | "autoDraft" | "dpRewriteRepublish" | "draft" | "future" | "inherit" | "pending" | "private" | "publish" | "requestCompleted" | "requestConfirmed" | "requestFailed" | "requestPending" | "trash" | "%future added value";
export type PostTemplateEnum = "brandedFullWidth" | "brandedPortrait" | "fullWidth" | "specialFeatureFullWidth" | "specialFeatureOverlay" | "specialFeatureSquare" | "square" | "%future added value";
export type ResourceTypeEnum = "authorProfile" | "campaign" | "category" | "clientError" | "customStory" | "diningReport" | "embedStory" | "homepage" | "image" | "internalCategory" | "internalSuperCat" | "linkPost" | "loopNav" | "map" | "mmaEvent" | "mmaFight" | "mmaFighter" | "mmaPromotion" | "mmaWeightClass" | "neighborhood" | "package" | "page" | "post" | "product" | "productBrand" | "quickPost" | "redirect" | "series" | "startHere" | "stream" | "superCat" | "tag" | "vault" | "venue" | "videoGame" | "videoGamePlatform" | "videoPost" | "volumeVideo" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContentResourceAnalyticsContainer_contentResource$data = {
  readonly __typename: string;
  readonly authors?: ReadonlyArray<{
    readonly name: string;
  }>;
  readonly blocks?: ReadonlyArray<{
    readonly __typename: "HighlightBlockType";
    readonly __typename: "HighlightBlockType";
  } | {
    readonly __typename: "LegacyProductBlockType";
    readonly legacyProduct: {
      readonly __typename: "LegacyProductBlockProductType";
    };
  } | {
    readonly __typename: "LegacyProductsTableBlockType";
    readonly legacyProducts: ReadonlyArray<{
      readonly __typename: "LegacyProductBlockProductType";
    }>;
  } | {
    readonly __typename: "ProductBlockType";
    readonly product: {
      readonly __typename: "ProductBlockProductType";
    };
  } | {
    readonly __typename: "ProductsTableBlockType";
    readonly products: ReadonlyArray<{
      readonly __typename: "ProductBlockProductType";
    }>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
  readonly categories?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly hasAffiliateLinks: boolean;
  readonly id: string;
  readonly internalCategories?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly internalSuperCats?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly liveStatus?: {
    readonly startAt: string | null;
  };
  readonly originalPublishedAt: string | null;
  readonly package?: {
    readonly id: string;
  } | null;
  readonly permalink: string;
  readonly primaryCampaign: {
    readonly advertiserName: string;
    readonly title: string;
  } | null;
  readonly primaryCategory?: {
    readonly slug: string;
  };
  readonly promo: {
    readonly headline: string;
  };
  readonly publishedAt: string | null;
  readonly resourceType: ResourceTypeEnum;
  readonly seo: {
    readonly headline: string;
  };
  readonly social: {
    readonly headline: string;
  };
  readonly status: PostStatusEnum;
  readonly streamPublishedAt?: string | null;
  readonly streams?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
  readonly superCats?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly template?: PostTemplateEnum | null;
  readonly title: string;
  readonly wordCount: number;
  readonly wpId: number;
  readonly " $fragmentType": "ContentResourceAnalyticsContainer_contentResource";
};
export type ContentResourceAnalyticsContainer_contentResource$key = {
  readonly " $data"?: ContentResourceAnalyticsContainer_contentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentResourceAnalyticsContainer_contentResource">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "headline",
    "storageKey": null
  }
],
v4 = [
  (v1/*:: as any*/)
],
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  }
],
v6 = [
  (v0/*:: as any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentResourceAnalyticsContainer_contentResource",
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wpId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resourceType",
      "storageKey": null
    },
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permalink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalPublishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAffiliateLinks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CampaignResourceType",
      "kind": "LinkedField",
      "name": "primaryCampaign",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "advertiserName",
          "storageKey": null
        },
        (v2/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShareableDataType",
      "kind": "LinkedField",
      "name": "seo",
      "plural": false,
      "selections": (v3/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShareableDataType",
      "kind": "LinkedField",
      "name": "social",
      "plural": false,
      "selections": (v3/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PromoDataType",
      "kind": "LinkedField",
      "name": "promo",
      "plural": false,
      "selections": (v3/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wordCount",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PackageResourceType",
          "kind": "LinkedField",
          "name": "package",
          "plural": false,
          "selections": (v4/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 100
            }
          ],
          "concreteType": "FeedContentStreamsConnection",
          "kind": "LinkedField",
          "name": "streams",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StreamResourceType",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": (v4/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": "streams(first:100)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorProfileResourceType",
          "kind": "LinkedField",
          "name": "authors",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalSuperCatResourceType",
          "kind": "LinkedField",
          "name": "internalSuperCats",
          "plural": true,
          "selections": (v5/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SuperCatResourceType",
          "kind": "LinkedField",
          "name": "superCats",
          "plural": true,
          "selections": (v5/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalCategoryResourceType",
          "kind": "LinkedField",
          "name": "internalCategories",
          "plural": true,
          "selections": (v5/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CategoryResourceType",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": (v5/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CategoryResourceType",
          "kind": "LinkedField",
          "name": "primaryCategory",
          "plural": false,
          "selections": (v5/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LiveStatusType",
          "kind": "LinkedField",
          "name": "liveStatus",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "blocks",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductBlockProductType",
                  "kind": "LinkedField",
                  "name": "product",
                  "plural": false,
                  "selections": (v6/*:: as any*/),
                  "storageKey": null
                }
              ],
              "type": "ProductBlockType",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LegacyProductBlockProductType",
                  "kind": "LinkedField",
                  "name": "legacyProduct",
                  "plural": false,
                  "selections": (v6/*:: as any*/),
                  "storageKey": null
                }
              ],
              "type": "LegacyProductBlockType",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductBlockProductType",
                  "kind": "LinkedField",
                  "name": "products",
                  "plural": true,
                  "selections": (v6/*:: as any*/),
                  "storageKey": null
                }
              ],
              "type": "ProductsTableBlockType",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LegacyProductBlockProductType",
                  "kind": "LinkedField",
                  "name": "legacyProducts",
                  "plural": true,
                  "selections": (v6/*:: as any*/),
                  "storageKey": null
                }
              ],
              "type": "LegacyProductsTableBlockType",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "template",
              "storageKey": null
            }
          ],
          "type": "PostResourceType",
          "abstractKey": null
        }
      ],
      "type": "FeedContentResourceInterface",
      "abstractKey": "__isFeedContentResourceInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "streamPublishedAt",
          "storageKey": null
        }
      ],
      "type": "StreamResourceType",
      "abstractKey": null
    }
  ],
  "type": "ContentResourceInterface",
  "abstractKey": "__isContentResourceInterface"
};
})();

(node as any).hash = "2df873a2deb01a267c3fa9dd603d4457";

export default node;
